import { Component, OnInit } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import { HttpClient } from '@angular/common/http'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  constructor(private HttpClient: HttpClient) {}
  ngOnInit() {
    // alert('yoooooo')
    // return false
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts